const Error = () => {
  return <div>That page doesn't exist!</div>;
};
export default Error;
